import TileLayer from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";

export const tileWMS = new TileLayer({
  source: new TileWMS({
    url: 'https://sgx.geodatenzentrum.de/wms_basemapde',
    params: {LAYERS: 'de_basemapde_web_raster_farbe', TILED: true, WIDTH: 256, HEIGHT: 256},
    serverType: 'geoserver'
  })
});

export const nrwMask = new VectorLayer({
  source: new VectorSource({
    url: 'assets/json/geomdata/brd_mask.geojson',
    format: new GeoJSON({
      dataProjection: 'EPSG:3857'
    })
  }),
  style: {
    'fill-color': ['string', ['get', 'COLOR'], '#ffffff77'],
  },
});
